module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIJeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCXdpZHRoPSI0MnB4IiBoZWlnaHQ9IjI4cHgiIHZpZXdCb3g9IjAgMCA0MiAyOCI+PHBhdGggZD0iTSAxOS41IDI1LjRDIDE5LjUgMjUuNCAyLjYxIDUuNjIgMi42MSA1LjYyIDEuMjcgNC4yOSAyLjIxIDIgNC4xIDIgNC4xIDIgMzcuODkgMiAzNy44OSAyIDM5Ljc4IDIgNDAuNzIgNC4yOSAzOS4zOCA1LjYyIDM5LjM4IDUuNjIgMjIuNDkgMjUuNCAyMi40OSAyNS40IDIxLjY2IDI2LjIyIDIwLjMzIDI2LjIyIDE5LjUgMjUuNFoiIGZpbGw9IiM1Nzc5RkEiIC8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/handle.svg
// module id = YOOE
// module chunks = 16